import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import {
    Container,
    Row,
    Col,
    Button,
    Card,
    CardBody,
    Label,
    Input,
    Spinner,
    //Table,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../../components/ButtonSpinner"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
    PaginationProvider,
    PaginationListStandalone,
    SizePerPageDropdownStandalone,
    PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { ToastContainer, toast } from "react-toastify"

//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as issuesAction from "../../../store/bWFuYWdlSXNzdWVz/actions"
import Modal from "react-bootstrap/Modal"
import api from "helpers/Api"

const ManageIssues = (props) => {
    // const { SearchBar } = Search
    const title = "Manage Issues"
    const { dispatch, searchBtnStyle } = props

    useEffect(() => {
        dispatch(issuesAction.loadRecordsMetaData())
        dispatch(
            issuesAction.loadIssues({
                page: 1,
                limit: 50,
            })
        )
    }, [])
    const sessionUpdate = useSelector((specificstate) => specificstate.session)

    const { user = [] } = sessionUpdate

    //Date format
    const dateSetting =
        !isEmpty(user) && user.setting && user.setting.dateFormate
            ? user.setting.dateFormate.toUpperCase()
            : []

    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

    //Reducer store state maintenance
    const specificDispatch = useDispatch()

    const eventCompleteUpdate = useSelector((state) => state.manageIssues)

    const { recordsMetaData = {}, data_copy_details = [] } = eventCompleteUpdate


    //manageIssues initial state setManageIssues
    const [manageIssues, setManageIssues] = useState({
        issuesFromDate: "",
        issuesToDate: "",
        nextFollowupFromDate: "",
        nextFollowupToDate: "",
        lastUpdatedDateFrom: "",
        lastUpdatedDateToDate: ""
    })
    //dropdown list
    const [department, setDepartment] = useState([])
    const [crmName, setCrmName] = useState([])
    const [pocEmployee, setPocEmployee] = useState([])
    const [issuesStatus, setIssuesStatus] = useState([])


    //handle change
    const handleChange = async (e) => {
        setManageIssues({ ...manageIssues, [e.target.name]: e.target.value })
    }



    const [resetManager, setResetManager] = useState(false)

    //reset functionalities
    const resetForm = () => {
        setDepartment([])
        setIssuesStatus([])
        setCrmName([])
        setPocEmployee([])
        setSearchInput("")
        setResetManager(true)
        setTimeout(() => {
            setResetManager(false)
        }, 0)
        setManageIssues({
            issuesFromDate: "",
            issuesToDate: "",
            nextFollowupFromDate: "",
            nextFollowupToDate: "",
            lastUpdatedDateFrom: "",
            lastUpdatedDateToDate: ""
        })

        dispatch(
            issuesAction.loadIssues({
                page: 1,
                limit: 50,
            })
        )
    }
    const fuseOptions = {
        keys: ["empCode", "label"],
    }
    //button spinner state
    const [btnLoader, setBtnLoader] = useState(false)
    //dropdown options

    const [pageCount, setPageCount] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [downloadLoading, setDownloadLoading] = useState(false)
    const [pageChange, setPageChange] = useState(false)

    //Search value
    // const [searchValueList, setSearchValueList] = useState({})
    const [searchFilter, setSearchFilter] = useState(false)
    const [searchInput, setSearchInput] = useState("")

    //apply filter submit

    const applyFilter = (e) => {
        e.preventDefault()
        var searchDepartment = !isEmpty(department) && department ? department.value : ""

        var searchIssuesFromDate =
            manageIssues && manageIssues.issuesFromDate
                ? moment(manageIssues.issuesFromDate).format("YYYY-MM-DD")
                : ""
        var searchIssuesToDate =
            manageIssues && manageIssues.issuesToDate
                ? moment(manageIssues.issuesToDate).format("YYYY-MM-DD")
                : ""
        var searchNextFromDate =
            manageIssues && manageIssues.nextFollowupFromDate
                ? moment(manageIssues.nextFollowupFromDate).format("YYYY-MM-DD")
                : ""
        var searchNextToDate =
            manageIssues && manageIssues.nextFollowupToDate
                ? moment(manageIssues.nextFollowupToDate).format("YYYY-MM-DD")
                : ""
        var searchCrm = !isEmpty(crmName) && crmName ? crmName.value : ""

        var searchPoc = !isEmpty(pocEmployee) && pocEmployee ? pocEmployee.value : ""

        var searchIssues = !isEmpty(issuesStatus) && issuesStatus ? issuesStatus.value : ""
        var searchUpdatedFromDate =
            manageIssues && manageIssues.lastUpdatedDateFrom
                ? moment(manageIssues.lastUpdatedDateFrom).format("YYYY-MM-DD")
                : ""
        var searchUpdatedToDate =
            manageIssues && manageIssues.lastUpdatedDateToDate
                ? moment(manageIssues.lastUpdatedDateToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}
        searchvalue.page = pageChange ? pageCount : 1
        searchvalue.limit = sizePerPage ? sizePerPage : 50
        if (searchDepartment) {
            searchvalue.departmentId = searchDepartment
        }
        if (searchIssuesFromDate) {
            searchvalue.issuesFromDate = searchIssuesFromDate
        }
        if (searchIssuesToDate) {
            searchvalue.issuesToDate = searchIssuesToDate
        }
        if (searchNextFromDate) {
            searchvalue.nextFollowupFromDate = searchNextFromDate
        }
        if (searchNextToDate) {
            searchvalue.nextFollowupToDate = searchNextToDate
        }
        if (searchIssues) {
            searchvalue.issuesStatus = searchIssues
        }
        if (searchPoc) {
            searchvalue.POC_EmployeeId = searchPoc
        }
        if (searchCrm) {
            searchvalue.CRM_Id = searchCrm
        }
        if (searchUpdatedFromDate) {
            searchvalue.lastUpdatedFromDate = searchUpdatedFromDate
        }
        if (searchUpdatedToDate) {
            searchvalue.lastUpdatedToDate = searchUpdatedToDate
        }

        //  setSearchValueList(searchvalue)
        setBtnLoading(true)
        specificDispatch(issuesAction.loadIssues(searchvalue))
        setTimeout(() => {
            setBtnLoader(false)
            setBtnLoading(false)
        }, 2000)
    }


    //data table

    let slNo = 0
    const copyDataTable =
        !isEmpty(data_copy_details) && data_copy_details.data.length > 0
            ? data_copy_details.data.map((data, index) => {
                slNo = slNo + 1
                const eventDate = data && data.eventDates ? data.eventDates.filter((date) => date !== null || date !== undefined)
                    .map((date) => moment(date).format(dateFormat))
                    .join(", ") : "--"
                const eventName = data && data.events ? data.events.filter((name) => name.eventName !== null || name.eventName !== undefined)
                    .map((name) => name.eventName)
                    .join(", ") : "--"

                const issuePOC_EmployeeName = data && !isEmpty(data.issuePOC_EmployeeName) ?
                    data.issuePOC_EmployeeName.filter(m => m.name != undefined && m.name != "").map(m => m.name).join(",") : "--"
                return {
                    _id: data._id,
                    sNo: slNo,
                    index: index,
                    leadNo: data.leadNo,
                    brideName: data.brideName ? data.brideName : "--",
                    groomName: data.groomName ? data.groomName : "--",
                    eventName: eventName,
                    eventDate: eventDate,
                    issueDepartment: data.issueDepartment ? data.issueDepartment : "--",
                    issuePoc: issuePOC_EmployeeName,
                    issueDate: data.issuesDate ? moment(data.issuesDate).format(dateFormat) : "--",
                    crmName: data.CRM_Name ? data.CRM_Name : "--",
                    issueDescription: data.issuesDescription ? data.issuesDescription : "--",
                    internalFollowupComments: data.internalFollowupComments ? data.internalFollowupComments : "--",
                    nextFollowupDate: data.nextFollowupDate ? moment(data.nextFollowupDate).format(dateFormat) : "--",
                    followupAgeing: data.followupAgeing ? Math.abs(data.followupAgeing) : "--",
                    issueStatus: data.issueStatus ? data.issueStatus : "--",
                    lastUpdatedDate: data.lastUpdatedDate ? moment(data.lastUpdatedDate).format(dateFormat) : "--",
                    sollutionOffered: data.solutionOffered ? data.solutionOffered : "--",
                }
            })
            : []




    //columns for data table
    const initialColumns = [
        {
            dataField: "sNo",
            text: "S.No",
            hidden: false,
        },
        {
            dataField: "leadNo",
            text: "Lead No",
            csvExport: false,
            hidden: false,

            style: {
                color: "#e40d8c",
                textTransform: "uppercase",
            },
            headerStyle: {
                minWidth: "145px",
            },
        },
        {
            dataField: "brideName",
            text: "Bride Name",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "groomName",
            text: "Groom Name",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "eventName",
            text: "Event Name",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "eventDate",
            text: "Event Date",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },

        {
            dataField: "issueDepartment",
            text: "Issue Department",
            hidden: false,
            headerStyle: {
                minWidth: "160px",
            },
        },
        {
            dataField: "issuePoc",
            text: "Issue POC Employee Name",
            hidden: false,
            headerStyle: {
                minWidth: "210px",
            },
        },
        {
            dataField: "issueDate",
            text: "Issue Date",
            hidden: false,
            headerStyle: {
                minWidth: "160px",
            },
        },
        {
            dataField: "crmName",
            text: "CRM Name",
            hidden: false,
            style: {
                textTransform: "uppercase",
            },
            headerStyle: {
                minWidth: "150px",
            },
        },
        {
            dataField: "issueDescription",
            text: "Issues Description",
            hidden: false,
            headerStyle: {
                minWidth: "170px",
            },
        },
        {
            dataField: "internalFollowupComments",
            text: "Internal Followup Comments",
            hidden: false,
            style: {
                textTransform: "uppercase",
            },
            headerStyle: {
                minWidth: "230px",
            },
        },
        {
            dataField: "nextFollowupDate",
            text: "Next Followup Date",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "followupAgeing",
            text: "Followup Ageing",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },
        {
            dataField: "issueStatus",
            text: "Issue Status",
            hidden: false,
            headerStyle: {
                minWidth: "165px",
            },
        },

        {
            dataField: "lastUpdatedDate",
            text: "Last Updated Date",
            hidden: false,
            headerStyle: {
                minWidth: "180px",
            },
        },
        {
            dataField: "sollutionOffered",
            text: "Sollution Offered",
            hidden: false,
            headerStyle: {
                minWidth: "180px",
            },
        },

    ]

    const [columns, setColumns] = useState(initialColumns)
    const [columnModal, setColumnModal] = useState(false)

    const [oddColumnData, setOddColumnData] = useState([])
    const [evenColumnData, setEvenColumnData] = useState([])
    useEffect(() => {
        if (columns && columns.length > 0) {
            var array = columns
            var evenColumns = []
            var oddColumns = []

            for (var i = 0; i < array.length; i++) {
                if (i % 2 === 0) {
                    oddColumns.push(array[i])
                } else {
                    evenColumns.push(array[i])
                }
            }

            setOddColumnData(oddColumns)
            setEvenColumnData(evenColumns)
        }
    }, [columns])

    const selectColumn = columns
        .filter((column) => column.hidden === false)
        .map((column) => column.dataField)

    const [selectedColumns, setSelectedColumns] = useState(selectColumn)

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target

        let updatedSelectedColumns
        if (checked) {
            updatedSelectedColumns = [...selectedColumns, value]
        } else {
            updatedSelectedColumns = selectedColumns.filter(
                (column) => column !== value
            )
        }

        setSelectedColumns(updatedSelectedColumns)
    }

    //  "Select All" checkbox
    const handleSelectAllChange = (e) => {
        const { checked } = e.target
        if (checked) {
            const allColumns = columns.map((column) => column.dataField)
            setSelectedColumns(allColumns)
        } else {
            const restoredColumns = initialColumns
                .filter((column) => !column.hidden)
                .map((column) => column.dataField)
            setSelectedColumns(restoredColumns)
        }
    }

    const handleSaveColumns = () => {
        setColumnModal(false)

        const updatedColumns = columns.map((column) => {
            const isColumnSelected = selectedColumns.includes(column.dataField)
            return { ...column, hidden: !isColumnSelected }
        })

        setColumns(updatedColumns)
        // default columns
        const defaultColumns = initialColumns.filter((column) => !column.hidden)
        const selectedNonDefaultColumns = selectedColumns.filter(
            (column) =>
                !defaultColumns.some(
                    (defaultColumn) => defaultColumn.dataField === column
                )
        )

        if (selectedNonDefaultColumns.length > 0) {
            toast.success("New Columns added successfully!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000,
            })
        }
    }

    const handleRestoreToDefault = () => {
        const restoreColumns = initialColumns
            .filter((column) => !column.hidden)
            .map((column) => column.dataField)

        setSelectedColumns(restoreColumns)
    }



    //Search filter

    const handleClick = (e) => {
        e.preventDefault()
        setSearchFilter(true)
        dispatch(
            issuesAction.loadIssues({
                searchFilter: searchInput,
                page: pageChange ? pageCount : 1,
                limit: 50,
            })
        )
        setTimeout(() => {
            setSearchFilter(false)
        }, 1200)
    }

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })

        const a = document.createElement("a")
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportToCsv = () => {
        var searchDepartment = !isEmpty(department) && department ? department.value : ""

        var searchIssuesFromDate =
            manageIssues && manageIssues.issuesFromDate
                ? moment(manageIssues.issuesFromDate).format("YYYY-MM-DD")
                : ""
        var searchIssuesToDate =
            manageIssues && manageIssues.issuesToDate
                ? moment(manageIssues.issuesToDate).format("YYYY-MM-DD")
                : ""
        var searchNextFromDate =
            manageIssues && manageIssues.nextFollowupFromDate
                ? moment(manageIssues.nextFollowupFromDate).format("YYYY-MM-DD")
                : ""
        var searchNextToDate =
            manageIssues && manageIssues.nextFollowupToDate
                ? moment(manageIssues.nextFollowupToDate).format("YYYY-MM-DD")
                : ""
        var searchCrm = !isEmpty(crmName) && crmName ? crmName.value : ""

        var searchPoc = !isEmpty(pocEmployee) && pocEmployee ? pocEmployee.value : ""

        var searchIssues = !isEmpty(issuesStatus) && issuesStatus ? issuesStatus.value : ""
        var searchUpdatedFromDate =
            manageIssues && manageIssues.lastUpdatedDateFrom
                ? moment(manageIssues.lastUpdatedDateFrom).format("YYYY-MM-DD")
                : ""
        var searchUpdatedToDate =
            manageIssues && manageIssues.lastUpdatedDateToDate
                ? moment(manageIssues.lastUpdatedDateToDate).format("YYYY-MM-DD")
                : ""

        var searchvalue = {}

        if (searchDepartment) {
            searchvalue.departmentId = searchDepartment
        }
        if (searchIssuesFromDate) {
            searchvalue.issuesFromDate = searchIssuesFromDate
        }
        if (searchIssuesToDate) {
            searchvalue.issuesToDate = searchIssuesToDate
        }
        if (searchNextFromDate) {
            searchvalue.nextFollowupFromDate = searchNextFromDate
        }
        if (searchNextToDate) {
            searchvalue.nextFollowupToDate = searchNextToDate
        }
        if (searchIssues) {
            searchvalue.issuesStatus = searchIssues
        }
        if (searchPoc) {
            searchvalue.POC_EmployeeId = searchPoc
        }
        if (searchCrm) {
            searchvalue.CRM_Id = searchCrm
        }
        if (searchUpdatedFromDate) {
            searchvalue.lastUpdatedFromDate = searchUpdatedFromDate
        }
        if (searchUpdatedToDate) {
            searchvalue.lastUpdatedToDate = searchUpdatedToDate
        }

        setPageLoad(!pageLoad)
        setDownloadLoading(true)
        api
            .post(`/manage_issues_export_excel`, searchvalue)
            .then((response) => {
                const copyExportDataTable = !isEmpty(response.data.data)
                    ? response.data.data.map((data, index) => {
                        const eventDate = data && data.eventDates ? data.eventDates.filter((date) => date !== null || date !== undefined)
                            .map((date) => moment(date).format(dateFormat))
                            .join(", ") : "--"
                        const eventName = data && data.events ? data.events.filter((name) => name.eventName !== null || name.eventName !== undefined)
                            .map((name) => name.eventName)
                            .join(", ") : "--"

                        const issuePOC_EmployeeName = data && !isEmpty(data.issuePOC_EmployeeName) ?
                            data.issuePOC_EmployeeName.filter(m => m.name != undefined && m.name != "").map(m => m.name).join(",") : "--"
                        const eventDateValue = !isEmpty(eventDate)
                            ? JSON.stringify(eventDate).replace(/","/g, "\n")
                            : "--"

                        const eventNameValue = !isEmpty(eventName)
                            ? JSON.stringify(eventName).replace(/","/g, "\n")
                            : "--"
                        const issuesDescriptionValue = !isEmpty(data.issuesDescription)
                            ? data.issuesDescription.replace(/[\r\n,.]/gm, "")
                            : "--"
                        //data.solutionOffered
                        const solutionOfferedValue = !isEmpty(data.solutionOffered)
                            ? data.solutionOffered.replace(/[\r\n,.]/gm, "")
                            : "--"
                        const internalFollowupCommentsValue = !isEmpty(data.internalFollowupComments)
                            ? data.internalFollowupComments.replace(/[\r\n,.]/gm, "")
                            : "--"
                        const issuePOC_EmployeeNameValue = !isEmpty(issuePOC_EmployeeName)
                            ? JSON.stringify(issuePOC_EmployeeName).replace(/","/g, "\n")
                            : "--"
                        return {
                            _id: data._id,
                            sNo: index + 1,
                            index: index,
                            leadNo: data.leadNo,
                            brideName: data.brideName ? data.brideName : "--",
                            groomName: data.groomName ? data.groomName : "--",
                            eventName: eventNameValue,
                            eventDate: eventDateValue,
                            issueDepartment: data.issueDepartment ? data.issueDepartment : "--",
                            issuePoc: issuePOC_EmployeeNameValue,
                            issueDate: data.issuesDate ? moment(data.issuesDate).format(dateFormat) : "--",
                            crmName: data.CRM_Name ? data.CRM_Name : "--",
                            issueDescription: issuesDescriptionValue,
                            internalFollowupComments: internalFollowupCommentsValue,
                            nextFollowupDate: data.nextFollowupDate ? moment(data.nextFollowupDate).format(dateFormat) : "--",
                            followupAgeing: data.followupAgeing ?  Math.abs(data.followupAgeing) : "--",
                            issueStatus: data.issueStatus ? data.issueStatus : "--",
                            lastUpdatedDate: data.lastUpdatedDate ? moment(data.lastUpdatedDate).format(dateFormat) : "--",
                            sollutionOffered: solutionOfferedValue,
                        }
                    })
                    : []
                setTimeout(() => {
                    let headerData = [
                        "SNo,Lead No,Bride Name,Groom Name,Event Name,Event Date,Issue Department,Issue POC Employee Name,Issue Date,CRM Name,Issues Description,Internal Followup Comments,Next Followup Date,Followup Ageing,Issue Status,Last Updated Date,Sollution Offered",
                    ]

                    let usersCsv =
                        !isEmpty(copyExportDataTable) &&
                        copyExportDataTable.reduce((acc, user) => {
                            const {
                                sNo,
                                leadNo,
                                brideName,
                                groomName,
                                eventName,
                                eventDate,
                                issueDepartment,
                                issuePoc,
                                issueDate,
                                crmName,
                                issueDescription,
                                internalFollowupComments,
                                nextFollowupDate,
                                followupAgeing,
                                issueStatus,
                                lastUpdatedDate,
                                sollutionOffered,

                            } = user
                            acc.push([
                                sNo,
                                leadNo,
                                brideName,
                                groomName,
                                eventName,
                                eventDate,
                                issueDepartment,
                                issuePoc,
                                issueDate,
                                crmName,
                                issueDescription,
                                internalFollowupComments,
                                nextFollowupDate,
                                followupAgeing,
                                issueStatus,
                                lastUpdatedDate,
                                sollutionOffered,

                            ])

                            return acc
                        }, [])

                    downloadFile({
                        data: [...headerData, ...usersCsv].join("\n"),
                        fileName: "ManageIssues.csv",
                        fileType: "text/csv",
                    })
                    setDownloadLoading(false)
                }, 1500)
                return response.data
            })
            .catch((error) => {
                Promise.reject(error)
                setDownloadLoading(false)
            })
    }

    const RemotePagination = ({
        data,
        page,
        // sort,
        sizePerPage,
        onTableChange,
        totalSize,
    }) => (
        <div>
            <PaginationProvider
                pagination={paginationFactory({
                    custom: true,
                    page,
                    // sort,
                    sizePerPage,
                    totalSize,
                })}
            >
                {({ paginationProps, paginationTableProps }) => (
                    <div>
                        <ToolkitProvider
                            keyField="index"
                            data={data}
                            columns={columns}
                            search
                            exportCSV
                        >
                            {() => (
                                <div>
                                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                        <Row className="d-flex flex-row">
                                            <Col className="mb-3" md="4"></Col>
                                            <Col
                                                md="8"
                                                style={{ marginBottom: "20px", marginTop: "-41px" }}
                                            >
                                                <div
                                                    style={{
                                                        float: "right",
                                                    }}
                                                >
                                                    <Button
                                                        className="btn btn-info"
                                                        onClick={() => setColumnModal(true)}
                                                    >
                                                        Edit Columns
                                                    </Button>
                                                </div>
                                                <div
                                                    style={{
                                                        float: "right",
                                                        marginRight: "10px",
                                                    }}
                                                >
                                                    {" "}
                                                    <Button
                                                        className="btn btn-primary"
                                                        onClick={exportToCsv}
                                                        id="download"
                                                        style={{
                                                            backgroundColor: "#e40d8c",
                                                            color: "white",
                                                            border: "none",
                                                        }}
                                                    >
                                                        Download
                                                    </Button>
                                                </div>
                                            </Col>

                                            <Col>
                                                <BootstrapTable
                                                    remote
                                                    keyField="index"
                                                    data={data}
                                                    id="ImportTable"
                                                    columns={columns}
                                                    responsive
                                                    noDataIndication={"No Data Found..."}
                                                    striped={true}
                                                    bordered={true}
                                                    onTableChange={onTableChange}
                                                    {...paginationTableProps}
                                                />
                                            </Col>
                                        </Row>
                                        <Row
                                            style={{ marginTop: "5px" }}
                                            className="align-items-md-center mt-30"
                                        >
                                            <Col className="inner-custom-pagination d-flex">
                                                <div className="d-inline d-flex flex-row">
                                                    <SizePerPageDropdownStandalone {...paginationProps} />
                                                    <div
                                                        style={{
                                                            fontSize: "14px",
                                                            marginTop: "8px",
                                                            marginLeft: "4px",
                                                        }}
                                                    >
                                                        <PaginationTotalStandalone {...paginationProps} />
                                                    </div>
                                                </div>
                                                <div
                                                    className="text-md-right ms-auto"
                                                    style={{ zIndex: 0 }}
                                                >
                                                    <PaginationListStandalone {...paginationProps} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>
                            )}
                        </ToolkitProvider>
                    </div>
                )}
            </PaginationProvider>
        </div>
    )
    const [pageLoad, setPageLoad] = useState(false)
    const [state, setState] = useState({
        sizePerPage: 50,
        page: 1,
        totalSize: data_copy_details.length,
        data:
            !isEmpty(data_copy_details) && data_copy_details.length > 0
                ? data_copy_details.slice(0, 50)
                : [],
    })
    const { sizePerPage, page } = state

    //Table Change

    const handleTableChange = (
        type,
        { page, sortField, sortOrder, currentIndex, sizePerPage }
    ) => {
        setPageCount(page)
        setPageChange(true)
        setPageLoad(!pageLoad)
        let result =
            !isEmpty(data_copy_details) && data_copy_details.length > 0
                ? data_copy_details
                : []
        if (
            !isEmpty(department) ||
            !isEmpty(manageIssues.issuesFromDate) ||
            !isEmpty(manageIssues.issuesToDate) ||
            !isEmpty(manageIssues.nextFollowupFromDate) ||
            !isEmpty(manageIssues.nextFollowupToDate) ||
            !isEmpty(manageIssues.lastUpdatedDateFrom) ||
            !isEmpty(manageIssues.lastUpdatedDateToDate) ||
            !isEmpty(issuesStatus) ||
            !isEmpty(crmName) ||
            !isEmpty(pocEmployee)
        ) {
            var searchDepartment = !isEmpty(department) && department ? department.value : ""

            var searchIssuesFromDate =
                manageIssues && manageIssues.issuesFromDate
                    ? moment(manageIssues.issuesFromDate).format("YYYY-MM-DD")
                    : ""
            var searchIssuesToDate =
                manageIssues && manageIssues.issuesToDate
                    ? moment(manageIssues.issuesToDate).format("YYYY-MM-DD")
                    : ""
            var searchNextFromDate =
                manageIssues && manageIssues.nextFollowupFromDate
                    ? moment(manageIssues.nextFollowupFromDate).format("YYYY-MM-DD")
                    : ""
            var searchNextToDate =
                manageIssues && manageIssues.nextFollowupToDate
                    ? moment(manageIssues.nextFollowupToDate).format("YYYY-MM-DD")
                    : ""
            var searchCrm = !isEmpty(crmName) && crmName ? crmName.value : ""

            var searchPoc = !isEmpty(pocEmployee) && pocEmployee ? pocEmployee.value : ""

            var searchIssues = !isEmpty(issuesStatus) && issuesStatus ? issuesStatus.value : ""
            var searchUpdatedFromDate =
                manageIssues && manageIssues.lastUpdatedDateFrom
                    ? moment(manageIssues.lastUpdatedDateFrom).format("YYYY-MM-DD")
                    : ""
            var searchUpdatedToDate =
                manageIssues && manageIssues.lastUpdatedDateToDate
                    ? moment(manageIssues.lastUpdatedDateToDate).format("YYYY-MM-DD")
                    : ""

            var searchvalue = {}
            searchvalue.page = pageChange ? pageCount : 1
            searchvalue.limit = sizePerPage ? sizePerPage : 50
            if (searchDepartment) {
                searchvalue.departmentId = searchDepartment
            }
            if (searchIssuesFromDate) {
                searchvalue.issuesFromDate = searchIssuesFromDate
            }
            if (searchIssuesToDate) {
                searchvalue.issuesToDate = searchIssuesToDate
            }
            if (searchNextFromDate) {
                searchvalue.nextFollowupFromDate = searchNextFromDate
            }
            if (searchNextToDate) {
                searchvalue.nextFollowupToDate = searchNextToDate
            }
            if (searchIssues) {
                searchvalue.issuesStatus = searchIssues
            }
            if (searchPoc) {
                searchvalue.POC_EmployeeId = searchPoc
            }
            if (searchCrm) {
                searchvalue.CRM_Id = searchCrm
            }
            if (searchUpdatedFromDate) {
                searchvalue.lastUpdatedFromDate = searchUpdatedFromDate
            }
            if (searchUpdatedToDate) {
                searchvalue.lastUpdatedToDate = searchUpdatedToDate
            }
            setPageLoad(!pageLoad)
            setLoading(true)
            specificDispatch(issuesAction.loadIssues(searchvalue))
        } else {
            dispatch(
                issuesAction.loadIssues({
                    page: page,
                    limit: sizePerPage,
                })
            )
            setLoading(true)
            setPageLoad(!pageLoad)
        }

        setTimeout(() => {
            setLoading(false)
        }, 2000)
        if (sortOrder === "asc") {
            result = result.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return 1
                } else if (b[sortField] > a[sortField]) {
                    return -1
                }
                return 0
            })
        } else {
            result = result.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return -1
                } else if (b[sortField] > a[sortField]) {
                    return 1
                }
                return 0
            })
        }

        setState(() => ({
            page,
            data: result.slice(currentIndex, currentIndex + sizePerPage),
            totalSize: result.length,
            sizePerPage,
        }))
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{title} | Zero Gravity CRM</title>
                </MetaTags>
                <Container fluid>
                    <Breadcrumbs title={"Operations"} breadcrumbItem={title} />

                    {/*form start */}
                    <Row>
                        <Col xs={12}>
                            <Card>
                                <CardBody>
                                    <form>
                                        <Row>

                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"} htmlFor={"Department"}>
                                                        {"Department"}
                                                    </Label>
                                                </div>
                                                <Select
                                                    type="text"
                                                    name="department"
                                                    value={department}
                                                    onChange={(e) => setDepartment(e)}
                                                    options={recordsMetaData.departmentOptions}
                                                    placeholder="Select Department"
                                                    classNamePrefix="select2-selection"
                                                />
                                            </Col>


                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className="form-label"
                                                        htmlFor={"Issues From Date"}
                                                    >
                                                        {"Issues From Date"}
                                                    </Label>
                                                </div>
                                                <Input
                                                    type="date"
                                                    placeholder="Select Date"
                                                    name="issuesFromDate"
                                                    value={manageIssues.issuesFromDate}
                                                    max={manageIssues.issuesToDate}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className="form-label"
                                                        htmlFor={"Issues To Date"}
                                                    >
                                                        {"Issues To Date"}
                                                    </Label>
                                                </div>
                                                <Input
                                                    type="date"
                                                    placeholder="Select Date"
                                                    name="issuesToDate"
                                                    value={manageIssues.issuesToDate}
                                                    min ={manageIssues.issuesFromDate}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className="form-label"
                                                        htmlFor={"Next Followup From Date"}
                                                    >
                                                        {"Next Followup From Date"}
                                                    </Label>
                                                </div>
                                                <Input
                                                    type="date"
                                                    placeholder="Select Date"
                                                    name="nextFollowupFromDate"
                                                    value={manageIssues.nextFollowupFromDate}
                                                    max={manageIssues.nextFollowupToDate}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className="form-label"
                                                        htmlFor={"Next Followup To Date"}
                                                    >
                                                        {"Next Followup To Date"}
                                                    </Label>
                                                </div>
                                                <Input
                                                    type="date"
                                                    placeholder="Select Date"
                                                    name="nextFollowupToDate"
                                                    value={manageIssues.nextFollowupToDate}
                                                    min={manageIssues.nextFollowupFromDate}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"}>{"CRM Name"}</Label>
                                                </div>
                                                <ReactSearchAutocomplete
                                                    name="crmName"
                                                    key={resetManager}
                                                    items={
                                                        !isEmpty(recordsMetaData)
                                                            ? recordsMetaData.employeeOptions
                                                            : []
                                                    }
                                                    value={crmName}
                                                    type="autoComplete"
                                                    resultStringKeyName="label"
                                                    showIcon={false}
                                                    onSelect={(e) => setCrmName(e)}
                                                    onClear={() => setCrmName([])}
                                                    onChange={(e) => setCrmName(e.target.value)}
                                                    placeholder="Enter CRM Name"
                                                    fuseOptions={fuseOptions} // Search on both fields
                                                    styling={{
                                                        height: "34px",
                                                        border: "1px solid #ced4da",
                                                        borderRadius: "4px",
                                                        backgroundColor: "white",
                                                        boxShadow: "none",
                                                        hoverBackgroundColor: "#E40D8C",
                                                        color: "black",
                                                        fontSize: "12px",
                                                        fontFamily: "Courier",
                                                        iconColor: "green",
                                                        clearIconMargin: "3px 8px 0 0",
                                                        zIndex: 10,
                                                    }}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"}>{"POC Employee Name"}</Label>
                                                </div>
                                                <ReactSearchAutocomplete
                                                    name="pocEmployee"
                                                    key={resetManager}
                                                    items={
                                                        !isEmpty(recordsMetaData)
                                                            ? recordsMetaData.employeeOptions
                                                            : []
                                                    }
                                                    value={pocEmployee}
                                                    type="autoComplete"
                                                    resultStringKeyName="label"
                                                    showIcon={false}
                                                    onSelect={(e) => setPocEmployee(e)}
                                                    onClear={() => setPocEmployee([])}
                                                    onChange={(e) => setPocEmployee(e.target.value)}
                                                    placeholder="Enter POC Employee"
                                                    fuseOptions={fuseOptions} // Search on both fields
                                                    styling={{
                                                        height: "34px",
                                                        border: "1px solid #ced4da",
                                                        borderRadius: "4px",
                                                        backgroundColor: "white",
                                                        boxShadow: "none",
                                                        hoverBackgroundColor: "#E40D8C",
                                                        color: "black",
                                                        fontSize: "12px",
                                                        fontFamily: "Courier",
                                                        iconColor: "green",
                                                        clearIconMargin: "3px 8px 0 0",
                                                        zIndex: 10,
                                                    }}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label className={"form-label"}>{"Issues Status"}</Label>
                                                </div>
                                                <Select
                                                    type="text"
                                                    name="issuesStatus"
                                                    value={issuesStatus}
                                                    // isMulti
                                                    onChange={(e) => setIssuesStatus(e)}
                                                    options={[{label:"Pending",value:"Pending"},{label:"Resolved",value:"Resolved"}]}
                                                    placeholder="Select Issues Status"
                                                    classNamePrefix="select2-selection"
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className="form-label"
                                                        htmlFor={"Last Updated From Date"}
                                                    >
                                                        {"Last Updated From Date"}
                                                    </Label>
                                                </div>
                                                <Input
                                                    type="date"
                                                    placeholder="Select Date"
                                                    name="lastUpdatedDateFrom"
                                                    value={manageIssues.lastUpdatedDateFrom}
                                                    max={manageIssues.lastUpdatedDateToDate}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </Col>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className="form-label"
                                                        htmlFor={"Last Updated To Date"}
                                                    >
                                                        {"Last Updated To Date"}
                                                    </Label>
                                                </div>
                                                <Input
                                                    type="date"
                                                    placeholder="Select Date"
                                                    name="lastUpdatedDateToDate"
                                                    value={manageIssues.lastUpdatedDateToDate}
                                                    min={manageIssues.lastUpdatedDateFrom}
                                                    onChange={(e) => handleChange(e)}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                                                <div
                                                    className="filter-buttons"
                                                    style={{ float: "right" }}
                                                >
                                                    <Button
                                                        type="button"
                                                        onClick={() => resetForm()}
                                                        className="btn btn-danger btn-label simple-form-Reset-btn"
                                                    >
                                                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                        Reset
                                                    </Button>
                                                    <Button
                                                        type="submit"
                                                        onClick={(e) => applyFilter(e)}
                                                        className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                                                    >
                                                        <i className="bx bx-filter-alt label-icon"></i>
                                                        {btnLoader && btnLoader ? (
                                                            <ButtonSpinner />
                                                        ) : (
                                                            "Apply Filter"
                                                        )}{" "}
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" lg="12" xl="12">
                            <Card>
                                <CardBody>
                                    <div
                                        className="d-flex flex-row"
                                        style={{ marginTop: "20px" }}
                                    >
                                        <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                            <form onSubmit={handleClick} className="d-flex flex-row">
                                                <div style={searchBtnStyle || null}>
                                                    <Input
                                                        type="text"
                                                        name="searchInput"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        className="form-control"
                                                        placeholder="Search"
                                                        style={{ position: "relative" }}
                                                    />
                                                    <i
                                                        className="bx bx-search-alt"
                                                        style={{
                                                            position: "absolute",
                                                            top: "54px",
                                                            left: "41px",
                                                            fontSize: "13px",
                                                        }}
                                                    />
                                                </div>
                                                <button
                                                    className="btn btn-success mx-2"
                                                    type="submit"
                                                    style={{
                                                        background: searchFilter ? "#2ca67a" : "",
                                                        color: searchFilter ? "#ffffff" : "",
                                                    }}
                                                >
                                                    <i className="fas fa-search"></i>
                                                </button>
                                            </form>
                                        </div>
                                    </div>{" "}
                                    <RemotePagination
                                        data={copyDataTable}
                                        page={page}
                                        sizePerPage={sizePerPage}
                                        totalSize={
                                            !isEmpty(data_copy_details)
                                                ? data_copy_details.totalDataCount
                                                : 0
                                        }
                                        onTableChange={handleTableChange}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                {columnModal && (
                    <Modal size="xl" show={columnModal}>
                        <Modal.Header
                            style={{
                                backgroundColor: "white",
                                color: "black",
                                fontSize: "16px",
                                fontWeight: "600",
                            }}
                        >
                            Edit Columns
                            <span>
                                <i
                                    className="fa fa-times quote-close"
                                    aria-hidden="true"
                                    onClick={() => setColumnModal(false)}
                                ></i>
                            </span>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <div>
                                    <Input
                                        type="checkbox"
                                        checked={selectedColumns.length === columns.length}
                                        onChange={(e) => handleSelectAllChange(e)}
                                        style={{ width: "15px", height: "15px" }}
                                    />
                                    <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                                        Select All
                                    </Label>
                                </div>
                            </Row>
                            <Row>
                                <Col sm="12" md="6" lg="6" className="ml-4">
                                    {oddColumnData.map((column) => (
                                        <div key={column.dataField} className="d-flex flex-row">
                                            <div className="form-check form-check-inline">
                                                <Input
                                                    type="checkbox"
                                                    value={column.dataField}
                                                    checked={selectedColumns.includes(column.dataField)}
                                                    onChange={(e) => handleCheckboxChange(e)}
                                                    style={{ width: "15px", height: "15px" }}
                                                />
                                                <Label
                                                    style={{
                                                        fontSize: "16px",
                                                        marginLeft: "10px",
                                                    }}
                                                >
                                                    {column.text}
                                                </Label>
                                            </div>
                                        </div>
                                    ))}
                                </Col>
                                <Col sm="12" md="6" lg="6">
                                    {evenColumnData.map((column) => (
                                        <div key={column.dataField} className="d-flex flex-row">
                                            <div className="form-check form-check-inline">
                                                <Input
                                                    type="checkbox"
                                                    value={column.dataField}
                                                    checked={selectedColumns.includes(column.dataField)}
                                                    onChange={(e) => handleCheckboxChange(e)}
                                                    style={{ width: "15px", height: "15px" }}
                                                />
                                                <Label
                                                    style={{
                                                        fontSize: "16px",
                                                        marginLeft: "10px",
                                                    }}
                                                >
                                                    {column.text}
                                                </Label>
                                            </div>
                                        </div>
                                    ))}
                                </Col>
                            </Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <p
                                className="text-decoration-underline text-info"
                                style={{ cursor: "pointer", fontSize: "16px" }}
                                onClick={handleRestoreToDefault}
                            >
                                Restore To Default
                            </p>
                            <Button
                                variant="secondary"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    setColumnModal(false)
                                    setSelectedColumns(selectColumn)
                                }}
                            >
                                Close
                            </Button>
                            <Button
                                variant="primary"
                                className="btn btn-success"
                                onClick={() => handleSaveColumns()}
                            >
                                Submit
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
                {btnLoading ? (
                    <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
                        <Modal.Body>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="lg"
                                role="status"
                                aria-hidden="true"
                                variant="success"
                                className="mx-2"
                                color="success"
                            />
                        </Modal.Body>
                    </Modal>
                ) : (
                    ""
                )}
                {loading ? (
                    <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
                        <Modal.Body>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="lg"
                                role="status"
                                aria-hidden="true"
                                variant="success"
                                className="mx-2"
                                color="success"
                            />
                        </Modal.Body>
                    </Modal>
                ) : (
                    ""
                )}
                {downloadLoading ? (
                    <Modal
                        show={downloadLoading}
                        style={{ width: "7%", margin: "18% 50%" }}
                    >
                        <Modal.Body>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="lg"
                                role="status"
                                aria-hidden="true"
                                variant="success"
                                className="mx-2"
                                color="success"
                            />
                        </Modal.Body>
                    </Modal>
                ) : (
                    ""
                )}

                <ToastContainer
                    position="top-right"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </div>
        </React.Fragment>
    )
}
//ManageIssues
ManageIssues.propTypes = {
    dispatch: PropTypes.func,
    searchProps: PropTypes.func,
    baseProps: PropTypes.any,
    searchBtnStyle: PropTypes.any,
    csvProps: PropTypes.any,
    onSearch: PropTypes.func,
    onExport: PropTypes.func,
    pageClick: PropTypes.any,
    data: PropTypes.array.isRequired,
    page: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    totalSize: PropTypes.number.isRequired,
    sizePerPage: PropTypes.number.isRequired,
    onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({
    //mapstate to props
})
//ManageIssues
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ManageIssues)
)
